import { ChainId } from '@adaswap/sdk'
import MULTICALL_ABI from 'constants/multicall/MulticalAbi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.TESTNET]: '0x4352074544dbffc8dc3a8387cdad82d9407f2b45',
  [ChainId.MAINNET]: '0xc3bFCe2D7b1B3494009f8c4d842A041D0707C815'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
